import { List, ListItem } from "@mui/material";
import { Child } from "../../../Interface/scheduler/form";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";

const ListItemWithIcon = ({ element }: { element: Child }) => {
  return (
    <div className={element.id} key={element.id}>
      <List>
        {element.items?.map((item) => (
          <ListItem key={item.id}>
            <div className="icon-block">
              {item?.icon ? <CheckCircleSharpIcon /> : null}
              <div className="icon-block-text">
                <p className="list-text">{item.text} </p>
              </div>
            </div>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default ListItemWithIcon;
